/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import {
  faAddressBook,
  faArrowsAlt,
  faAt,
  faBell,
  faBuilding,
  faCalendarAlt,
  faCarBattery,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCompressArrowsAlt,
  faDiceD20,
  faDownload,
  faEdit,
  faEye,
  faEyeSlash,
  faFax,
  faFile,
  faFileDownload,
  faFileUpload,
  faFrown,
  faGlobeAmericas,
  faHashtag,
  faKey,
  faLeaf,
  faListAlt,
  faLocationArrow,
  faLock,
  faMapMarkerAlt,
  faMarker,
  faMicrochip,
  faMinus,
  faMinusCircle,
  faNetworkWired,
  faPaperclip,
  faPhone,
  faPhoneAlt,
  faPhoneSquareAlt,
  faPlug,
  faPlus,
  faPlusCircle,
  faListUl,
  faMapMarkedAlt,
  faPowerOff,
  faQuestion,
  faSave,
  faServer,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSimCard,
  faSmile,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faTabletAlt,
  faTimes,
  faTrashAlt,
  faTrophy,
  faUpload,
  faUser,
  faUsers,
  faWindowClose,
  faWrench,
  faAngleDown,
  faWifi,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons/faAddressCard';
import { faEthernet } from '@fortawesome/free-solid-svg-icons/faEthernet';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import * as CompanyActions from './actions/Companies';
import * as BoxesActions from './actions/EpikBoxes';
import * as UserActions from './actions/User';
import { logout } from './actions/User';
import { ErrorBoundary } from './components/ErrorBoundary';
import * as UsersActions from './actions/Users';
import './App.css';
// import CacheBuster from 'react-cache-buster';
// import {version} from '../package.json';

import Layout from './Layout';
import CountDownModal from './components/CountdownModal';
import moment from 'moment';
import { getTrunkGroupList } from './actions/Inteliquent';
import { getTdmRoutes } from './actions/tdm';
import { getUserPermissionGroup } from './actions/PermissionGroups';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import WebsiteNotificationBar from '../src/components/WebsiteNotificationBar';
import 'leaflet/dist/leaflet.css';
import { addSystemLogs } from '../src/actions/SystemLogs';


library.add([
  faPaperclip,
  faUpload,
  faFile,
  faSignInAlt,
  faSignOutAlt,
  faAddressBook,
  faBuilding,
  faPowerOff,
  faMarker,
  faClock,
  faSignature,
  faCarBattery,
  faHashtag,
  faMicrochip,
  faDiceD20,
  faCalendarAlt,
  faMapMarkerAlt,
  faNetworkWired,
  faEthernet,
  faAddressCard,
  faEdit,
  faTrophy,
  faServer,
  faSimCard,
  faWindowClose,
  faKey,
  faAt,
  faChevronRight,
  faChevronLeft,
  faCaretLeft,
  faCaretRight,
  faPlus,
  faTimes,
  faSpinner,
  faCheck,
  faArrowsAlt,
  faSave,
  faCheckCircle,
  faFileDownload,
  faEye,
  faTrashAlt,
  faSort,
  faMinus,
  faCompressArrowsAlt,
  faPlug,
  faPlusCircle,
  faMapMarkedAlt,
  faListUl,
  faMinusCircle,
  faCaretUp,
  faCaretDown,
  faSortDown,
  faSortUp,
  faFileUpload,
  faFax,
  faUser,
  faGlobeAmericas,
  faLocationArrow,
  faUsers,
  faPhoneAlt,
  faLeaf,
  faTabletAlt,
  faBell,
  faWrench,
  faPhoneSquareAlt,
  faSmile,
  faFrown,
  faStar,
  faLock,
  faPhone,
  faQuestion,
  faDownload,
  faListAlt,
  faEye,
  faEyeSlash,
  faAngleDown,
  faWifi,
  faExclamationTriangle,
]);
require('dotenv').config();

const SESSION_TIME = parseInt(process.env.REACT_APP_SESSION_TIMEOUT, 10) || 30;
const TIMEOUT_IN_MILI_SECONDS = 1000 * 60 * SESSION_TIME;
const TIMEOUT_IN_MINUTES = SESSION_TIME;

class App extends Component {
  constructor(props) {
    super(props);
    this.hasLoggedInactivity = false;
    this.token = localStorage.getItem('jwtToken') || null;
    global.deleteMode = false;
    if (
      window.location.pathname.indexOf('/boxes/') !== -1 &&
      window.location.search.indexOf('&token=') !== -1
    ) {
      this.token = window.location.search.split('&token=').pop();
      localStorage.clear();
      localStorage.setItem('jwtToken', this.token);
    }
    if (!this.token || this.token === 'null' || this.token === 'undefined') {
      localStorage.removeItem('jwtToken');
      this.token = null;
    }
    props.getUserData(this.token);
    props.getUserPermissionGroup(this.token)
    if (this.token) {
      props.getTrunkGroupList(this.token);
      props.getTdmRoutes(this.token);
      this.hasLoggedInactivity = false;
    }
    this.idleTimer = null;
    this.state = {
      isModalOpen: false,
      currWidth: window.innerWidth,
      maintenanceText: '',
    };
    props.latestMaintenanceNote().then((result) => {
      if (result && result?.maintenanceAlert?.length > 0) {
        this.setState({
          maintenanceText: result?.maintenanceAlert[0]?.description,
        });
      }
    });
    if (this.token) {
      // Clear session-related local storage items upon login
      localStorage.removeItem('countdown-modal-open');
      localStorage.removeItem('idle-timer');
      localStorage.removeItem('lastActivity');
    }
  }

  onIdle = async() => {
    if (this.hasLoggedInactivity) return; 
    this.hasLoggedInactivity = true;
    const { logout,addSystemLogs } = this.props;
    this.setState({ isModalOpen: true });
    localStorage.setItem('countdown-modal-open', 'true');
    
    const body = {
      actionType: 'system',
      description: `Forced logout due to inactivity.`
    };
    await addSystemLogs(this.token, body);
    logout(this.token, this.props.intervalId);
    this.token = null;
    this.setState({ timeoutDuration: null });
    this.setBlurTimer();
  };

  syncActivityAcrossTabs = (event) => {
    if (event.key === 'countdown-modal-open') {
      const isModalOpen = event.newValue === 'true';
      if (!document.hasFocus()) {
        this.setState({ isModalOpen });
      }
    } else if (event.key === 'close-countdown-modal') {
      this.setState({ isModalOpen: false });
      this.resetIdleTimer();
    } else if (event.key === 'reset-idle-timer') {
      this.resetIdleTimer();
    } else if (event.key === 'sync-last-activity') {
      this.updateUserActivityTimestamp();
    }
  };
  
  toggle = () => {
    if(!document.hasFocus()){
      this.onIdle();
    }else{
      const { isModalOpen } = this.state;
      const newModalState = !isModalOpen;
      this.setState({ isModalOpen: newModalState });
      localStorage.setItem('countdown-modal-open', newModalState ? 'true' : 'false');
      this.setBlurTimer();
      if (newModalState) {
        this.updateUserActivityTimestamp();
      }
    }
  };
  
  
  handleStillThereClick = () => {
    // Close the countdown modal
    this.setState({ isModalOpen: false });
    // Update local storage to reset countdown state across tabs
    localStorage.setItem('countdown-modal-open', 'false');
    localStorage.setItem('close-countdown-modal', Date.now());
    // Reset the idle timer
    this.resetIdleTimer();
    // Reset the inactivity flag
    this.hasLoggedInactivity = false;
  };
  

  handleResize = () => this.setState({ currWidth: window.innerWidth });
  handleVisibilityChange = () => {
    console.log('Visibility Change Event:', document.visibilityState);
    if (document.visibilityState === 'hidden') {
      this.setBlurTimer();
    } else {
      this.resetIdleTimer();
    }
  };
  
// Updated focus event handling
componentDidMount() {

  // update cookie if token exits
  // set cookie interval to update cookies
  let interval = null
  // if (this.token) {
  //   interval = setInterval(() => {
  //     this.props.setCookies(this.token)
  //   }, 20000); //interval duration 20sec
  //   this.props.setIntervalId(interval)
  //   this.hasLoggedInactivity = false;
  // }

  if (this.token) {
    const lastActivity = localStorage.getItem('lastActivity');
    if (lastActivity) {
      const currentTime = moment();
      const activityDuration = moment.duration(currentTime.diff(parseInt(lastActivity, 10))).asMinutes();
      if (activityDuration > TIMEOUT_IN_MINUTES) {
        this.onIdle();
        return;
      }
    }
  }

  this.reAuthenticateUser();
  window.addEventListener('resize', this.handleResize);
  window.addEventListener('blur', this.setBlurTimer);
  window.addEventListener('focus', this.reAuthenticateUser);
  window.addEventListener('visibilitychange', this.handleVisibilityChange);
  window.addEventListener('storage', this.syncActivityAcrossTabs);
  this.setUserActivityListeners();

  (async () => {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    console.log('visitorId', visitorId);
    sessionStorage.setItem("userDeviceID", visitorId);
  })();

  const isModalOpen = localStorage.getItem('countdown-modal-open') === 'true';
  this.setState({ isModalOpen });
}
componentWillUnmount() {
  this.setBlurTimer();
  window.removeEventListener('blur', this.setBlurTimer);
  window.removeEventListener('resize', this.handleResize);
  window.removeEventListener('focus', this.reAuthenticateUser);
  window.removeEventListener('storage', this.syncActivityAcrossTabs);
  this.removeUserActivityListeners();
  clearInterval(this.props.intervalId)
}
  setBlurTimer = () => {
    localStorage.setItem('idle-timer',Date.now());
  };

  reAuthenticateUser = () => {
    const previousTime = localStorage.getItem('idle-timer');
    const lastActivity = localStorage.getItem('lastActivity');
    if (previousTime && lastActivity) {
      const currentTime = moment();
      const idleDuration = moment.duration(currentTime.diff(previousTime)).asMinutes();
      const activityDuration = moment.duration(currentTime.diff(parseInt(lastActivity, 10))).asMinutes();
      if (idleDuration > TIMEOUT_IN_MINUTES || activityDuration > TIMEOUT_IN_MINUTES) {
        this.onIdle();
      } else {
        this.resetIdleTimer();
        this.hasLoggedInactivity = false;
      }
    }
  };

  setUserActivityListeners = () => {
    window.addEventListener('mousemove', this.updateUserActivityTimestamp);
    window.addEventListener('keypress', this.updateUserActivityTimestamp);
    window.addEventListener('scroll', this.updateUserActivityTimestamp);
    window.addEventListener('click', this.updateUserActivityTimestamp);
  };

  removeUserActivityListeners = () => {
    window.removeEventListener('mousemove', this.updateUserActivityTimestamp);
    window.removeEventListener('keypress', this.updateUserActivityTimestamp);
    window.removeEventListener('scroll', this.updateUserActivityTimestamp);
    window.removeEventListener('click', this.updateUserActivityTimestamp);
  };

  updateUserActivityTimestamp = () => {
    localStorage.setItem('lastActivity', Date.now());
    this.resetIdleTimer();
  };

  resetIdleTimer = () => {
    if (this.idleTimer) {
      this.idleTimer.reset();
    }
  };

  render() {
    const { isModalOpen, maintenanceText } = this.state;
    return (
      // <CacheBuster
      // currentVersion={version}
      // isEnabled={true}
      // isVerboseMode={true}
      // >
      <DndProvider
        backend={this.state.currWidth <= 1024 ? TouchBackend : HTML5Backend}
        options={{ enableMouseEvents: true }}
      >
        <div className="text-center">
          {!this.token && maintenanceText && (
            <WebsiteNotificationBar isOpen={true} >{maintenanceText}</WebsiteNotificationBar>
          )}
          <ErrorBoundary>
            {this.token && (
              <IdleTimer
                ref={ref => {
                  this.idleTimer = ref;
                }}
                element={document}
                onIdle={this.toggle}
                debounce={250}
                timeout={TIMEOUT_IN_MILI_SECONDS}
              />
            )}
            {this.token && (
              <CountDownModal toggle={this.toggle} isModalOpen={isModalOpen} onIdle={this.onIdle} handleStillThereClick={this.handleStillThereClick}
              />
            )}
            <ToastContainer autoClose={5000} position="top-left" />
            <Layout />
          </ErrorBoundary>
        </div>
      </DndProvider>
      // </CacheBuster>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  user: state.AppState.user,
  intervalId: state.UIState.users.intervalId
});
const mapDispatchToProps = dispatch => ({
  getUserData: token => dispatch(UserActions.getUserData(token)),
  getTrunkGroupList: token => dispatch(getTrunkGroupList(token)),
  getUserPermissionGroup: token => dispatch(getUserPermissionGroup(token)),
  getTdmRoutes: token => dispatch(getTdmRoutes(token)),
  getCompanies: (token, pagination, disablePaginate, onlyName) =>
    dispatch(
      CompanyActions.getCompanies(
        token,
        pagination,
        disablePaginate,
        undefined,
        undefined,
        onlyName,
      ),
    ),
  getBoxes: (token, companyId) => dispatch(BoxesActions.getEpikBoxesData(token, companyId)),
  getUsers: (token, pagination) => dispatch(UsersActions.getUsers(token, pagination)),
  setCookies: (token) => dispatch(UsersActions.setCookies(token)),
  setIntervalId: (interval) => dispatch(UsersActions.setIntervalId(interval)),
  logout: (token, intervalId) => dispatch(logout(token, intervalId)),
  latestMaintenanceNote: token => dispatch(BoxesActions.latestMaintenanceNote()),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);






